export default function Menu(props = {}) {

  return (
    <ul className="nav sidebar-menu">
      {props.children}
    </ul>
  )
}